export default "__VITE_ASSET__aff226c4__"